import React from 'react'
import styled from '@emotion/styled'
import { Colors, Shapes } from 'src/components/theme'

type InsightCardBorderProps = {
  children?: React.ReactNode
}

export const InsightCardBorderWrapper = styled.div`
  margin: ${Shapes.spacing[4]}px 0;
  padding: ${Shapes.spacing[4]}px;
  border: 1px solid ${Colors.border};
  border-radius: ${Shapes.borderRadius}px;
`

export const InsightCardBorder: React.FC<InsightCardBorderProps> = (props) => {
  const { children } = props

  return <InsightCardBorderWrapper>{children}</InsightCardBorderWrapper>
}
